// Generated by scripts/generate-web-routes.ts. Page behavior lives in app/.
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/(portal)/dashboard/billing/page";
import { parseAtlasSearch } from "@/lib/navigation-target";
import { toPageHead } from "@/lib/page-metadata";
import { loadRoutePage } from "@/lib/page-route";
import { buildRootMetadata } from "@/lib/site-metadata";
import Loading from "@/app/(portal)/dashboard/loading";

export const Route = createFileRoute("/_portal/dashboard/billing/")({
  loaderDeps: ({ search }) => search,
  loader: ({ params, location }) => loadRoutePage(
    () => import("@/app/(portal)/dashboard/billing/page"),
    { params, searchParams: parseAtlasSearch(location.searchStr) },
    "/_portal/dashboard/billing/",
  ),
  head: ({ loaderData }) => toPageHead(loaderData?.metadata ?? {}, {
    parent: buildRootMetadata(),
  }),
  component: PageRoute,
  pendingComponent: Loading,
});

function PageRoute() {
  return <Page data={Route.useLoaderData().data} />;
}
